import styled from "@emotion/styled";
import { MDSText } from "@/mds/components/text";

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.smPlus};
  padding: ${({ theme }) => theme.spacing[5]} 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.background.card.default};
  flex-shrink: 0;
  width: 100%;
  max-width: 784px;
`;

export const StyledSectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 ${({ theme }) => theme.spacing[5]};
  align-self: stretch;
`;

export const StyledSectionHeaderText = styled(MDSText)(({ theme }) => ({
  fontSize: theme.fontSizes.medium,
  fontWeight: theme.fontWeights.medium,
  color: theme.colors.text.primary,
  margin: 0,
}));

export const StyledSectionSeparator = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing[1]} 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.smPlus};
  align-self: stretch;
`;

export const StyledSectionSeparatorLine = styled.div`
  background: ${({ theme }) => theme.colors.border.ghost};
  height: 1px;
  width: 100%;
`;
